export default function TextWhenYou() {
  return (
    <p className="leading-tight text-base text-gray-500 || mb-c12">
      When you book a trip or experience, messages from your host will show up
      here.
    </p>
  );
}
